import React, { useState } from 'react';
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import rating1Default from "../../../images/ratings/rating-1-default.svg";
import rating2Default from "../../../images/ratings/rating-2-default.svg";
import rating3Default from "../../../images/ratings/rating-3-default.svg";
import rating4Default from "../../../images/ratings/rating-4-default.svg";
import rating5Default from "../../../images/ratings/rating-5-default.svg";

import rating1Pressed from "../../../images/ratings/rating-1-pressed.svg";
import rating2Pressed from "../../../images/ratings/rating-2-pressed.svg";
import rating3Pressed from "../../../images/ratings/rating-3-pressed.svg";
import rating4Pressed from "../../../images/ratings/rating-4-pressed.svg";
import rating5Pressed from "../../../images/ratings/rating-5-pressed.svg";


/**
 * RatingRow component for displaying a row of rating images.
 * Handles rating selection with hover and selected states.
 * 
 * @param {Object} props
 * @param {number|undefined} props.rating - Current rating value
 * @param {Function} props.setRating - Function to update rating value
 * @returns {JSX.Element} Row of rating images
 */
const ProductFeedbackRating = ({ rating, setRating }) => {
    const [hoveredRating, setHoveredRating] = useState(undefined);

    const ratingImages = {
        default: [rating1Default, rating2Default, rating3Default, rating4Default, rating5Default],
        pressed: [rating1Pressed, rating2Pressed, rating3Pressed, rating4Pressed, rating5Pressed],
    };

    const getRatingImage = (value) => {
        if (value === hoveredRating || value === rating) {
            return ratingImages.pressed[value - 1];
        }
        return ratingImages.default[value - 1];
    };

    return (
        <Row alignmentHorizontal="center" spacing="300">
            {[1, 2, 3, 4, 5].map((value) => (
                <Column key={value} alignmentHorizontal="center" spacing="none">
                    <Row height="37px" alignmentVertical="bottom" spacingInset="none none 200 none">
                        <Text type="h50">
                            {(value === rating) ? value : ''}
                        </Text>
                    </Row>
                    <img
                        key={value}
                        src={getRatingImage(value)}
                        alt={`Rating ${value}`}
                        style={{ 
                            cursor: 'pointer'
                        }}
                        onClick={() => setRating(value)}
                        onMouseEnter={() => setHoveredRating(value)}
                        onMouseLeave={() => setHoveredRating(null)}
                    />
                    <Row height="40px"/>
                </Column>
            ))}
        </Row>
    );
};

export default ProductFeedbackRating;